import React, { useState, useEffect } from "react";
import TextInput from "../common/TextInput";

type ChangePasswordModalProps = {
  isOpen: boolean;
  onClose: Function;
  onSubmit: Function;
  user: any;
  onChange: Function;
};

const ChangePasswordModal = ({
  isOpen,
  onClose,
  onSubmit,
  user,
  onChange,
}: ChangePasswordModalProps) => {
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setConfirmPassword("");
      setError("");
    }
  }, [isOpen]);

  // Validate passwords whenever either field changes
  useEffect(() => {
    // Clear error if no input provided
    if (!user.password && !confirmPassword) {
      setError("");
      return;
    }

    // Check password length
    if (user.password && user.password.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    //check password max length
    if (user.password && user.password.length > 19) {
      setError("Password cannot be longer than 20 characters long");
      return;
    }

    // Check password match if both fields have values
    if (user.password && confirmPassword) {
      if (confirmPassword !== user.password) {
        setError("Passwords do not match");
      } else {
        setError("");
      }
    }
  }, [confirmPassword, user.password]);

  if (!isOpen) {
    return null;
  }

  const handlePasswordChange = (e: any) => {
    onChange(e);
    // Validation will be handled by the useEffect
  };

  const handleConfirmPasswordChange = (e: any) => {
    const newValue = e.target.value;
    setConfirmPassword(newValue);
    onChange(e);
    // Validation will be handled by the useEffect
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg w-2/3 p-6 shadow-lg">
        <div className="flex justify-between items-center border-b pb-3">
          <h2 className="text-xl font-semibold">Change Password</h2>
          <button
            onClick={() => onClose()}
            className="text-gray-500 hover:text-gray-700"
          >
            &times;
          </button>
        </div>

        <div className="flex flex-col">
          <div className="mr-2 w-full">
            <TextInput
              name={"password"}
              label={"New Password"}
              placeholder={""}
              value={user.password}
              error={() => {}}
              disabled={false}
              className={"bg-white-800 p-2 w-full rounded shadow"}
              type={"password"}
              initialFocus={true}
              onChange={handlePasswordChange}
            />
          </div>
          <div className="mr-2 w-full">
            <TextInput
              name={"passwordConfirmation"}
              label={"Confirm Password"}
              placeholder={""}
              value={confirmPassword}
              error={() => {}}
              disabled={false}
              className={"bg-white-800 p-2 w-full rounded shadow"}
              type={"password"}
              initialFocus={false}
              onChange={handleConfirmPasswordChange}
            />
          </div>
          {error && <p className="text-red-500">{error}</p>}
        </div>
        <div className="flex justify-end mt-6">
          <button
            onClick={(e) => onSubmit(e)}
            className={`py-2 px-4 ml-2 rounded ${
              error || !user.password || !confirmPassword
                ? "bg-tealBlue-200 "
                : "bg-tealBlue-500 hover:bg-tealBlue-700"
            }`}
            disabled={!!error || !user.password || !confirmPassword}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
